import React, {useState} from 'react';
import {LockOutlined, Visibility, VisibilityOff} from "@mui/icons-material";
import {IconButton, InputAdornment, TextField} from "@mui/material";
import T from 'i18n-react';

const PasswordInput = ({isError}) => {

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordHandler = () => {
        setShowPassword(prevState => !prevState);
    }

    return (
        <TextField
            name={'password'}
            type={showPassword ? 'text' : 'password'}
            placeholder={T.translate('loginComponent.password')}
            error={isError}
            InputProps={{
                startAdornment: (
                    <InputAdornment position={'start'}>
                        <LockOutlined/>
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={togglePasswordHandler}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff/> : <Visibility/>}
                        </IconButton>
                    </InputAdornment>
                )
            }}
        />
    )

}

export default PasswordInput;
